import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import styled, { css } from "styled-components";
import CheckIcon from '@material-ui/icons/Check';

export default function OptionCard({ data, isSelected = false }) {
    const [bgColor] = React.useState(window.Util.getMaterialColor());

    return (
        <div style={{
            display: "flex",
            padding: "10px 10px 10px 0px"
            // justifyContent: "space-between"
        }}>
            <Avatar style={{
                backgroundColor: isSelected ? "#237ff4" : bgColor
            }}>
                {
                    isSelected
                        ? <StyledCheckIcon />
                        : data.full_name?.trim()[0] || data.email[0]
                }
            </Avatar>
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                // justifyContent: "space-between",
                paddingLeft: 10
            }}>
                <StyledDiv isSelected={isSelected}>{data.full_name}</StyledDiv>
                <StyledDiv isSelected={isSelected}>{data.email}</StyledDiv>
            </div>
        </div>
    );
}

const StyledDiv = styled.div`
    ${(props) =>
        props.isSelected &&
        css`
            font-weight: 600;
    `};
`;

const StyledCheckIcon = styled(CheckIcon)`
    && {
        color: #fff;
        font-size: 24px;
    }
`;